import { useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { LoggedInHome, SignUp } from "pages";

import { LoggedInLayout, SignUpLayout } from "layouts";
import { FeatureFlag } from "models/auth/types";
import { useCurrentUser } from "providers/CurrentUserProvider";
import ApplicationRoutes from "../application";

export default function ExternalUserRouter(): JSX.Element {
	const user = useCurrentUser();
	const externalUserCompletedRegistration = useMemo(
		() => user?.hasCompletedRegistration(),
		[user?.additionalInfo]
	);
	const defaultRedirectUrl = user?.defaultRedirectUrl() ?? "/";

	return (
		<Routes>
			<Route
				path="/"
				element={
					externalUserCompletedRegistration ? (
						<LoggedInLayout />
					) : (
						<Navigate to="/cadastro" />
					)
				}
			>
				<Route path="/" element={<LoggedInHome />} />
				{user?.hasFeatureEnabled(FeatureFlag.CREATE_APPLICATION) && (
					<Route path="/solicitacao/*" element={<ApplicationRoutes />} />
				)}
			</Route>
			<Route path="/cadastro" element={<SignUpLayout />}>
				<Route
					path="/cadastro"
					element={
						externalUserCompletedRegistration ? <Navigate to="/" /> : <SignUp />
					}
				/>
			</Route>
			<Route path="*" element={<Navigate to={defaultRedirectUrl} />} />
		</Routes>
	);
}
